import TYPES from '@/modules/shared/types';

// Domain
import { TemplateQuestionnaireRepository } from '../../domain/repository';
import { TemplateQuestionnaireEntity } from '../../domain/entities/template-questionnaire-entity';
import { FilterDto } from '../../domain/dtos/filter-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class TemplateQuestionnaireHttpRepository
implements TemplateQuestionnaireRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/templates-questionnaires/search?where={WHERE}`;

  execute(filter_questionnaire: FilterDto): Promise<Array<TemplateQuestionnaireEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{WHERE}', JSON.stringify(filter_questionnaire)))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
